import React, { useEffect, useState } from "react"
import { toast } from "react-toastify"
import { HiPencil } from "react-icons/hi"
import api from "../../services/api"
import BreakForm from "../../components/Form/BreakForm"
import LimitSettings from "../../components/Modal/ModalOutboundCampaign/LimitSettings"
import Loading from "../layouts/Loading"

const CampaignLimitSettings = () => {
    const [settings, setSettings] = useState({})
    const [inboxes, setInboxes] = useState([])
    const [editable, setEditable] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        getLimitSettings()
    }, [])

    const getLimitSettings = async () => {
        setIsLoading(true)
        try {
            const response = await api.get("/outbound-campaigns/limit-settings")
            const data = response?.data?.data || {}
            setSettings(data.settings || {})
            setInboxes(data.inboxes || [])
        } catch (err) {
            toast.error(err?.response?.data?.message)
        } finally {
            setIsLoading(false)
        }
    }

    const handleSaveLimitSettings = async (nextSettings) => {
        setIsLoading(true)
        try {
            const response = await api.patch("/outbound-campaigns/limit-settings", { settings: nextSettings })
            setSettings(response?.data?.data || nextSettings)
            setEditable(false)
            toast.success(response?.data?.message)
        } catch (err) {
            toast.error(err?.response?.data?.message)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <>
            <BreakForm
                title="Limites de campanhas"
                iconAction={<HiPencil />}
                actionVariant="secondary"
                handleAction={() => setEditable(true)}
                showAction={!editable && !isLoading}
            />
            <LimitSettings
                settings={settings}
                inboxes={inboxes}
                canUpdate={true}
                editable={editable}
                isSaving={isLoading}
                wrapModal={false}
                onCancel={() => setEditable(false)}
                onSubmit={handleSaveLimitSettings}
            />
            {isLoading && <Loading fullPage={true} />}
        </>
    )
}

export default CampaignLimitSettings
